import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register } from 'swiper/element/bundle';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

// Register Swiper custom elements
register();

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.sentryEnvironment,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Enable sending logs to Sentry
  enableLogs: true,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  Sentry.logger.error('bootstrap_failed', {
    errorMessage: err instanceof Error ? err.message : String(err),
  }),
);
